import React from "react"

const DarkWave = () => (
  <svg className="wave_svg"
    width="1440"
    height="175"
    viewBox="0 0 1440 175"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1440 175H0V0C240 53.3333 480 80 720 80C960 80 1200 53.3333 1440 0V175Z"
      fill="white"
    />
  </svg>
)
export default DarkWave
